module.exports = __webpack_public_path__ + "img/stock4.3c3ff7e2.png";